import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dados-bloco-senatran',
  templateUrl: './dados-bloco-senatran.component.html',
  styleUrls: ['./dados-bloco-senatran.component.scss']
})
export class DadosBlocoSenatranComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
